import { render, staticRenderFns } from "./TaskAttachPrice.vue?vue&type=template&id=0d6246d0&scoped=true&"
import script from "./TaskAttachPrice.vue?vue&type=script&lang=js&"
export * from "./TaskAttachPrice.vue?vue&type=script&lang=js&"
import style0 from "./TaskAttachPrice.vue?vue&type=style&index=0&id=0d6246d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6246d0",
  null
  
)

export default component.exports